<template>
    <div class="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>
                <router-link class="btn btn-sm" :to="{ name: 'RoutingRouteMapList' }"
                  ><i class="fas fa-chevron-left"></i>
                </router-link>
                Routing Route Map
              </h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <router-link :to="{ name: 'Home' }">Home</router-link>
                </li>
                <li class="breadcrumb-item active">Routing Route Map</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section class="content">
        <div class="container-fluid">
          <div class="card" id="RoutingRouteMap">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <form @submit.prevent="handleSubmission()" method="POST" novalidate>
              <div class="card-header">
                <h3 class="card-title" v-if="!is_edit">Create</h3>
                <h3 class="card-title" v-if="is_edit">Edit</h3>
              </div>
              <div class="card-body pb-1">
                <div class="row">
                  <div class="col-md-8">

                    <div class="form-group required">
                      <label class="control-label">Name</label>
                      <input
                        type="text"
                        id="map_name"
                        name="map_name"
                        v-bind:class="{ 'has-error': errors.has('map_name') }"
                        v-validate="{ required: true, regex: /^[A-Za-z_]+$/}"
                        v-model="value.map_name"
                        class="form-control map_name"
                        placeholder="Name"
                      />
                      <div class="help text-danger" v-show="errors.has('map_name')">
                        {{ `The name should only contains alphabet and underscrore.` }}
                      </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Sequence</label>
                      <input
                        type="text"
                        id="sequence"
                        name="sequence"
                        v-validate="'required|numeric|max:11'"
                        v-bind:class="{ 'has-error': errors.has('sequence') }"
                        v-model="value.sequence"
                        class="form-control sequence"
                        placeholder="Sequence"
                      />
                      <div class="help text-danger" v-show="errors.has('sequence')">
                        {{ errors.first("sequence") }}
                      </div>
                    </div>

                    <div class="form-group">
                        <label class="control-label">Match</label>
                        <multiselect
                        v-model="value.match"
                        :options="pre.match"
                        placeholder="Select Match"
                        :searchable="true"
                        :multiple="false"
                        id="match"
                        @input="setListOption"
                        v-bind:class="{
                            'has-error': errors.has('match'),
                        }"
                        name="match"
                        >
                        </multiselect>
                        <div class="help text-danger" v-show="errors.has('match')">
                        {{ errors.first("match") }}
                        </div>
                    </div>

                    <div class="form-group required">
                    <label class="control-label">List</label>
                    <multiselect
                      v-model="value.list_id"
                      :options="Object.keys(pre.list)"
                      :custom-label="(opt) => pre.list[opt]"
                      placeholder="Select List"
                      :searchable="true"
                      :multiple="false"
                      id="list_id"
                      v-bind:class="{ 'has-error': errors.has('list_id') }"
                      v-validate="'required'"
                      name="list"
                    >
                    </multiselect>
                    <div class="help text-danger" v-show="errors.has('list')">
                      {{ errors.first("list") }}
                    </div>
                  </div>

                    <div class="form-group required">
                        <label class="control-label">Action</label>
                        <multiselect
                        v-model="value.action"
                        v-validate="'required'"
                        :options="pre.actions"
                        placeholder="Select Action"
                        :searchable="true"
                        :multiple="false"
                        id="action"
                        v-bind:class="{
                            'has-error': errors.has('action'),
                        }"
                        name="action"
                        >
                        </multiselect>
                        <div class="help text-danger" v-show="errors.has('action')">
                        {{ errors.first("action") }}
                        </div>
                    </div>

                    <div class="form-group">
                        <label class="control-label">Set</label>
                        <multiselect
                        v-model="value.set"
                        :options="pre.set"
                        placeholder="Select Set"
                        :searchable="true"
                        :multiple="false"
                        id="set"
                        @input="setValueLimit"
                        v-bind:class="{
                            'has-error': errors.has('set'),
                        }"
                        name="set"
                        >
                        </multiselect>
                        <div class="help text-danger" v-show="errors.has('set')">
                        {{ errors.first("set") }}
                        </div>
                    </div>

                    <div class="form-group required">
                      <label class="control-label">Value</label>
                      <input
                        type="text"
                        id="value"
                        name="value"
                        v-validate="{required: true, max_value: valueLimit, min_value: 0}"
                        v-bind:class="{ 'has-error': errors.has('value') }"
                        v-model="value.value"
                        class="form-control value"
                        placeholder="Value"
                      />
                      <div class="help text-danger" v-show="errors.has('value')">
                        {{ errors.first("value") }}
                      </div>
                    </div>

                    <div v-if="value.set == 'as-path prepend'" class="form-group">
                      <label class="control-label">As Number</label>
                      <input
                        type="text"
                        id="as_number"
                        name="as number"
                        v-validate="'numeric|max:5'"
                        v-bind:class="{ 'has-error': errors.has('as_number') }"
                        v-model="value.as_number"
                        class="form-control as_number"
                        placeholder="As Number"
                      />
                      <div class="help text-danger" v-show="errors.has('as number')">
                        {{ errors.first("as number") }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer pt-0 pb-4">
                <button type="submit" v-if="!is_edit" class="btn">Submit</button>
                <button type="submit" v-if="is_edit" class="btn">Update</button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  </template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import axios from "axios";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "RoutingRouteMapForm",
  metaInfo: {
    title: "Routing Route Map | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {
    },
    pre: {
      set: ['weight', 'local-preference', 'as-path prepend'],
      actions: ['permit', 'deny'],
      match: ['PREFIX_LIST'],
      list: {},
      prefixList: {},
      communityList: {}
    },
    valueLimit: Number.MAX_SAFE_INTEGER
  }),

  methods: {
    handleSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/routing_route_map";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/routing_route_map/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "RoutingRouteMapList" });
            })
            .catch((errors) => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message);
                _this.$setErrorsFromResponse(errors.response.data.errors);
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message);
                _this.$setErrorsFromResponse(errors.response.data);
              }
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = "/routing_route_map/" + id;
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      const _this = this
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((errors) => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          });
      } else {
        this.value.accountId = LocalStorage.get("accountId");
      }
      // await CommonAPI.getAudraName(LocalStorage.get("accountId"))
      //   .then((response) => {
      //     _this.pre.audraName = response;
      //   })
      //   .catch((error) => {
      //     console.log(error.response);
      //   });
      await this.getPrefixList()
        .then((response) => {
          _this.pre.prefixList = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    //   await this.getCommunityList()
    //     .then((response) => {
    //       _this.pre.communityList = response.data;
    //     })
    //     .catch((error) => {
    //       console.log(error.response);
    //     });
    //   this.setCustomValidation();
    
      this.setListOption()
      this.is_loading = false;
    },
    getPrefixList: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/get_prefix_list";
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },
    setValueLimit() {
      if (this.value.set == 'weight' || this.value.set == 'med') {
        this.valueLimit = 255;
      } else if (this.value.set == 'as-path-prepend') {
        this.valueLimit = 10;
      } else {
        this.valueLimit = Number.MAX_SAFE_INTEGER;
      }
    },
    setListOption() {
      if (this.value.match == 'PREFIX_LIST') {
        this.pre.list = this.pre.prefixList;
      }
    }
  },
  mounted() {
    this.initialize();
  },
};
</script>
